import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button, useTheme } from "@mui/material";

const ExportToExcel = ({ data, columns, fileName }) => {
    const theme = useTheme();

    const getExportValue = (row, col) => {
        if (typeof col.renderExport === "function") {
          return col.renderExport(row);
        }
      
        const value = typeof col.renderer === "function"
          ? col.renderer(row)
          : row[col.field];
      
        if (React.isValidElement(value)) return "";
        if (typeof value === "object" && value !== null) return JSON.stringify(value);
        return value ?? "";
      };

    const handleExport = () => {
        if (!data || data.length === 0) {
            alert("No data available to export.");
            return;
        }
        const header = columns.map(col => col.name);
        const body = data.map(row =>
            columns.map(col =>
                getExportValue(row, col)
            )
        );

        const worksheet = XLSX.utils.aoa_to_sheet([header, ...body]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(dataBlob, `${fileName}.xlsx`);
    };

    return <Button
        type='submit'
        variant="contained"
        sx={{
            backgroundColor: `${theme?.customSettings?.themeColor}`,
            color: '#FFF', padding: '7px 20px',
            fontWeight: '500', textTransform: 'none',
            fontSize: '16px', float: 'right'
        }} onClick={handleExport}>
        Export as Excel
    </Button>;
};

export default ExportToExcel;